// Firebase web app configuration for call-steward-notify project.
//
// These are PUBLIC client-side values (not secrets).
// NOTE: If these change, also update /firebase-messaging-sw.js at the document root.

export const firebaseConfig = {
  apiKey: 'AIzaSyASq3v1xUrkm_x0jAjnL26Ojg-1JabhYnw',
  authDomain: 'call-steward-notify.firebaseapp.com',
  projectId: 'call-steward-notify',
  storageBucket: 'call-steward-notify.firebasestorage.app',
  messagingSenderId: '175628539682',
  appId: '1:175628539682:web:823b5a8da7d93a9bab377b',
  measurementId: 'G-DKKB3ECS4S',
};

export const vapidKey = 'BHUBmx-L_9tuM6d3zLdMcv55c889Bg4dczyiKi1cURMbB9pNy3C551Z0iTaJkXR4Lb2P4Ikcr6ve1GATrkiPQxc';
